<template>
  <div>
    <v-dialog
      v-model="passwordChange"
      max-width="450px"
    >
      <v-card>
        <v-card-title class="text-h5 align-center">
          <v-text-field
            v-model="newPassword"
            :rules="[rules.required, rules.password]"
            label="Nova senha:"
            outlined
            dense
            :type="show ? 'text' : 'password'"
          >
            <template v-slot:append>
              <div style="top: -10px">
                <v-icon
                  class="pe-5"
                  title="Mostrar/Ocultar Senha"
                  @click="show = !show"
                >
                  {{ show ? 'mdi-eye' : 'mdi-eye-off' }}
                </v-icon>
                <v-icon
                  title="Gerar Senha Aleatória"
                  @click="createRandomPassword"
                >
                  mdi-autorenew
                </v-icon>
              </div>
            </template>
          </v-text-field>
        </v-card-title>
        <v-card-actions class="align-start d-flex justify-end pt-0 pe-7">
          <v-btn
            class="rounded-pill"
            text
            color="error"
            @click="passwordChange=false"
          >
            <v-icon
              left
            >
              mdi-cancel
            </v-icon>
            Cancelar
          </v-btn>
          <v-btn
            origin="bottom right"
            class="rounded-pill"
            color="success"
            @click="agreePassword()"
          >
            <v-icon
              left
            >
              mdi-content-save
            </v-icon>
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import rules from '../../../../services/rules'

  export default {
    name: 'ChangePassword',
    data () {
      return {
        newPassword: '',
        rules: rules,
        passwordChange: false,
        show: false,
      }
    },
    methods: {
      ...mapActions('users', ['changePassword', 'generateRandomPassword']),
      async change (id) {
        if (await this.openPasswordChanger()) {
          this.changePassword([this.newPassword, id])
          this.$alert('success', 'Senha alterada com sucesso')
          this.clearInputs()
        }
      },
      openPasswordChanger () {
        this.passwordChange = true
        return new Promise((resolve) => {
          this.resolve = resolve
        })
      },
      agreePassword () {
        this.resolve(true)
        this.passwordChange = false
      },
      clearInputs () {
        this.newPassword = ''
      },
      async createRandomPassword () {
        this.newPassword = await this.generateRandomPassword()
      },
    },
  }
</script>

<style scoped>

.rounded-pill {
  border-radius: 50px !important;
  text-transform: none !important;
  font-weight: 600;
}

</style>
